import { useSelector } from "react-redux";
import classes from "./Assessments.module.css"
import AssessmentRow from "./AssessmentRow"

const Assessments = ({ filteredlist, currentAssessmentId, setCurrentAssessmentId }) => {

    const { texts } = useSelector(state => state.translate);

    return (
        <>
            <div className={classes.Title} >
                <div className={classes.Slide}>{texts.slide}</div>
                <div className={classes.Question}>{texts.question}</div>
                <div className={classes.Score}>{texts.averageGrade}</div>
                <div className={classes.AnswewrdPercent}>{texts.responsePercentage}</div>
            </div>
            {
                filteredlist && filteredlist.map((asessment, index) =>
                    <AssessmentRow key={index} asessment={asessment} currentAssessmentId={currentAssessmentId} setCurrentAssessmentId={setCurrentAssessmentId}></AssessmentRow>
                )}

        </>
    )


}
export default Assessments